import React, { useContext, useEffect, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../components/Button'
import { ClassingContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import { getGroupCurators } from '../../../actions/groups'
import Loader from '../../../components/Loader'
import Table from '../../../components/Table'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { handleSortFio } from '../../../utils/handleSortFio'


export default function Curator() {

  const dispatch = useDispatch()
  const { classId, closeModal, infoCreateChange } = useContext(ClassingContext)
  const { groupCurators, modalLoading: loading } = useSelector(state => state.groups)

  const [sortArr, setSortArr] = useState(false)
  const [arr, setArr] = useState()

  useEffect(() => {
    if (classId && classId !== 'add') dispatch(getGroupCurators(classId))
  }, [])

  useEffect(() => {
    groupCurators && setArr([...groupCurators])
  }, [groupCurators])

  const renderRow = ({ calc_fio, calc_posts }) => (
    <tr>
      <td>{calc_fio}</td>
      <td>{calc_posts}</td>
      {/* <td>{calc_status}</td>  LMSTWO-63
      <td>{calc_date}</td> */}
    </tr>
  )

  const handleSort = () => {
    handleSortFio(arr, sortArr)
    setSortArr(!sortArr)
  }

  return (
    <>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          {loading
            ? <Loader />
            : !!arr?.length &&
            <div className={styles.tableScroll}>
              <Table maxHeight='60vh'>
                <thead>
                  <tr>
                    <th onClick={handleSort}>ФИО</th>
                    <th>Должность</th>
                  </tr>
                </thead>
                <tbody>
                  {arr.map(renderRow)}
                </tbody>
              </Table>
            </div>
          }
        </div>
      </div>
      <ModalFooter closeModal={closeModal} handleSubmit={closeModal} infoCreateChange={infoCreateChange} />
    </>
  )
}
